/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { WrappedPTG, WrappedPTGInterface } from "../WrappedPTG";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "holder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "prestigeID",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class WrappedPTG__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    holder: string,
    prestigeID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WrappedPTG> {
    return super.deploy(
      holder,
      prestigeID,
      overrides || {}
    ) as Promise<WrappedPTG>;
  }
  getDeployTransaction(
    holder: string,
    prestigeID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(holder, prestigeID, overrides || {});
  }
  attach(address: string): WrappedPTG {
    return super.attach(address) as WrappedPTG;
  }
  connect(signer: Signer): WrappedPTG__factory {
    return super.connect(signer) as WrappedPTG__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WrappedPTGInterface {
    return new utils.Interface(_abi) as WrappedPTGInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WrappedPTG {
    return new Contract(address, _abi, signerOrProvider) as WrappedPTG;
  }
}
